import React, { useEffect } from "react";
import { Table, Tooltip } from "antd";
import { ColumnsType } from "antd/es/table";
import { useMaintenanceModel } from "../maintenanceModel";
import { IMaintenanceDetail } from "../maintenanceTypes";
import { useDictModel } from "../../../base/dict/dictModel";
import YhTag from "@/components/YhTag";
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";



type statusType = {
    "maintenance.create": string,
    "maintenance.stock-io": string,
    "maintenance.settle": string,
    "maintenance.change": string,
    [key: string]: any
}

export function DataTable() {
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { language, setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)

    const {
        dataSource, selectedRowKeys, pgCfg, descRows,
        loadData, setSelectedRowKeys, setDescRows,
    } = useMaintenanceModel();
    const { getTreeSelectOne, getSelectedDictOne, getTreeNodeName, getTreeNodeOne } = useDictModel();
    const statusColor: statusType = {
        "maintenance.create": "blue",
        "maintenance.stock-io": "cyan",
        "maintenance.settle": "green",
        "maintenance.change": "red",
    }
    const columns: ColumnsType<IMaintenanceDetail> = [
        {
            // title: '序号',
            title: Locale["SN"],
            width: 80,
            fixed: "left",
            render: (t, r, i) => i + 1
        }, {
            // title: '工单单号',
            title: Locale["Maintenance Doc No."],
            width: 150,
            dataIndex: 'maintenanceCode',
            fixed: "left",
            // render: (text,record) => `${text}${record.appointmentCode?(<span className="click-span">转</span>):""}`,
            render: (text, record) => {
                if (record.appointmentCode) {
                    return (<div style={{ display: "flex" }}>{text}<span className="click-span pl-5">{Locale["turn"]}</span></div>)
                } else {
                    return text
                }
            }
        }, {
            // title: '单据状态',
            title: Locale["Status"],
            width: 120,
            dataIndex: 'status',
            render: (text) => <YhTag color={statusColor[text]} text={language == "zh-CN" ? getTreeNodeOne(text)[0].name : getTreeNodeOne(text)[0].nameEn as string} />,
        }, {
            title: '退单状态',
            width: 160,
            dataIndex: 'returnType',
            render: (text) => getTreeNodeName(text)
        }, {
            title: '支付状态',
            width: 160,
            dataIndex: 'payStatus',
            render: (text) => getTreeNodeName(text)
        }, {
            // title: '单据日期',
            title: Locale["Creation Time"],
            width: 180,
            ellipsis: true,
            dataIndex: 'createTime',
        }, {
            // title: '客户名称',
            title: Locale["Customer"],
            width: 160,
            dataIndex: 'customerName',
            render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,

        }, {
            // title: '车辆牌照',
            title: Locale["License Plate"],
            width: 160,
            dataIndex: 'licensePlate',
        }, {
            // title: 'VIN码',
            title: Locale["VIN"],
            width: 160,
            dataIndex: 'vin',
        }, {
            // title: '联系人',
            title: Locale["Contact"],
            width: 120,
            dataIndex: 'contact',
        }, {
            // title: '联系电话',
            title: Locale["Contact Number"],
            width: 160,
            dataIndex: 'phone',
        }, {
            // title: '维修类型',
            title: Locale["Service Type"],
            width: 160,
            dataIndex: 'serviceTypeCode',
            // render: (text) => getTreeNodeName(text)
            render: (text) => {
                if (text) {
                    return language == "zh-CN" ? getTreeNodeOne(text)[0].name : getTreeNodeOne(text)[0].nameEn as string
                } else {
                    return ""
                }
            }
         
        }, {
            // title: '工时费',
            title: Locale["Labor Cost"],
            width: 160,
            dataIndex: 'workingHoursAmount',
        }, {
            // title: '材料费',
            title: Locale["Material Cost"],
            width: 160,
            dataIndex: 'materialScienceAmount',
        }, {
            // title: '优惠金额',
            title: Locale["Discount Amount"],
            width: 160,
            dataIndex: 'discountTotalAmount',
        }, {
            // title: '费用合计',
            title: Locale["Total Amount"],
            width: 160,
            dataIndex: 'totalAmount',
            // render: (text) => (Number(text) * 1.15).toFixed(2)

        }, {
            // title: '已收金额',
            title: Locale["Received Amount"],
            width: 160,
            dataIndex: 'amountReceived',
        }, {
            // title: '进厂时间',
            title: Locale["Enter Time"],
            width: 180,
            ellipsis: true,
            dataIndex: 'enterTime',
        }, {
            // title: '出厂时间',
            title: Locale["Delivery Time"],
            width: 180,
            ellipsis: true,
            dataIndex: 'deliveryTime',
        }, {
            // title: '出库员',
            title: Locale["Storekeeper"],
            width: 180,
            ellipsis: true,
            dataIndex: 'storekeeper',
        }, {
            // title: '出库时间',
            title: Locale["Stock-out Time"],
            width: 180,
            ellipsis: true,
            dataIndex: 'stockIoTime',
        }, {
            // title: '结算员',
            title: Locale["Reckoner"],
            width: 180,
            ellipsis: true,
            dataIndex: 'reckoner',
        }, {
            // title: '结算时间',
            title: Locale["Settle Time"],
            width: 180,
            ellipsis: true,
            dataIndex: 'settleTime',
        }, {
            // title: '核销时间',
            title: Locale["Write off time"],
            width: 180,
            ellipsis: true,
            dataIndex: 'payTime',
        }, {
            // title: '制单员',
            title: Locale["Creator"],
            width: 160,
            dataIndex: 'createUser',
        }, {
            // title: '维修技师',
            title: Locale["Technician"],
            width: 160,
            dataIndex: 'technicianNames',
            // render: (text, record) => {
            //     let technicianNames: string[] = []
            //     record.itemDetails?.forEach((el, index) => {
            //         technicianNames = [...technicianNames, ...el?.technicianName.split(',') ?? []]
            //     })
            //     return Array.from(new Set(technicianNames)).toString();
            // }
        }, {
            // title: '打印次数',
            title: Locale["Print Times"],
            width: 160,
            dataIndex: 'printingTimes',
        }, {
            // title: '备注',
            title: Locale["Note"],
            width: 160,
            dataIndex: 'note',
        }, {
            // title: '结算类型',
            title: Locale["Payment Type"],
            width: 120,
            dataIndex: 'payType',
            fixed:"right",
            // render: (text) => getTreeNodeName(text)
            render: (text) => {
                if (text) {
                    return language == "zh-CN" ? getTreeNodeOne(text)[0].name : getTreeNodeOne(text)[0].nameEn as string
                } else {
                    return ""
                }
            }   
        }, {
            // title: '应收金额',
            title: Locale["Receivable Amount"],
            width: 140,
            dataIndex: 'receivableTotalAmount',
            fixed:"right",
        },
    ];
    useEffect(() => {
        loadData().then();
    }, [])

    //点击行选高亮
    const onRow = (record: IMaintenanceDetail) => {
        let { id } = record as { id: string }
        let findIndexDesc = descRows.findIndex((item) => (item.id === id))
        let newDescRows = [...descRows];
        let newSelectedRowKeys = [...selectedRowKeys];

        if (findIndexDesc === -1) {
            //统计数据
            newDescRows.push(record)
            setDescRows(newDescRows)
            //表格选中行Key值
            newSelectedRowKeys.push(id);
            setSelectedRowKeys(newSelectedRowKeys);
        } else {
            //统计数据
            newDescRows.splice(findIndexDesc, 1);
            setDescRows(newDescRows);
            //表格选中行Key值
            newSelectedRowKeys.splice(findIndexDesc, 1);
            setSelectedRowKeys(newSelectedRowKeys);
        }
    };

    return (
        <Table
            style={{ cursor: "pointer" }}
            rowKey={record => record.id as string}
            rowSelection={{
                onChange: (selectedRowKeys: React.Key[], selectedRows: IMaintenanceDetail[]) => {
                    setSelectedRowKeys(selectedRowKeys as string[]);
                    setDescRows(selectedRows)
                },
                selectedRowKeys
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ["bottomCenter"],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize }).then();
                }
            }}
            onRow={record => ({
                onClick: () => onRow(record)
            })}
            scroll={{ x: 'max-content', y: 500 }}
        />
    )
}
